import 'twin.macro';
import React from 'react';
import { format } from '@teetsh/app/src/utils/time/format';
import { PlusIcon as Plus } from '@heroicons/react/24/outline';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { Classroom } from '@teetsh/app/src/types/classroom';
import { useTranslation } from 'react-i18next';
import { useOpenCreateCJSeanceModal } from '../../../CreateCJSeanceModal/useOpenCreateCJSeanceModal';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { emptySeance } from 'containers/CahierJournal/CreateCJSeanceModal/emptySeance';
import tw from 'twin.macro';
import { backgroundColors } from '@teetsh/app/src/styles/themeConstants';

interface Props {
  start: Date;
  end: Date;
  visible: boolean;
  classrooms: Classroom[];
  className?: string;
  extraTopMargin?: boolean;
}

export function AddEventItem(props: Props) {
  const { start, end, visible, classrooms, className } = props;
  const { t } = useTranslation(['cahierJournal']);
  const open = useOpenCreateCJSeanceModal();
  const { guestMode } = useUser();
  const startString = format(start, 'fr-FR', "HH'h'mm");
  const endString = format(end, 'fr-FR', "HH'h'mm");

  const openModal = () =>
    open({
      classrooms,
      seance: emptySeance({ start, end, classrooms, type: 'classic' }),
    });
  if (guestMode?.permission === 'read') {
    if (!visible) {
      return null;
    }
    return (
      <div tw="text-xs text-muted text-center">
        {t('cahierJournal:labels.noItem')}
      </div>
    );
  }
  return (
    <div
      data-testid="add-event-hover"
      tw="relative w-full overflow-hidden print:hidden"
      className={className}
    >
      {visible ? (
        <div css={[props.extraTopMargin && tw`mt-3`]}>
          <Button
            icon={Plus}
            intent="primary"
            outlined
            onClick={() => openModal()}
            fill
          >
            {t('cahierJournal:actions.addSeance')}
          </Button>
        </div>
      ) : (
        <>
          <div
            tw="absolute top-0 bottom-0 right-0 left-0 flex items-center"
            aria-hidden="true"
          >
            <div
              css={[
                tw`w-full h-px bg-[length:8px] bg-center bg-repeat-x`,
                {
                  backgroundImage: `linear-gradient(to right, ${backgroundColors['brand-intense']} 50%, transparent 50%)`,
                },
              ]}
            />
          </div>
          <div tw="relative flex justify-center">
            <span tw="relative z-0 inline-flex shadow-sm rounded-md -space-x-px">
              <button
                type="button"
                onClick={() => openModal()}
                className="group"
                tw="relative inline-flex items-center px-1 py-1 rounded-full border border-brand-intense bg-brand-quiet text-sm font-medium text-brand-intense hover:bg-brand-moderate focus:z-10 focus:outline-none"
              >
                <Plus tw="h-4 w-4 invisible" aria-hidden="true" />
                <Plus
                  tw="transition duration-200 ease-in-out absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-4 w-4 transform hover:text-primary group-hover:scale-150"
                  aria-hidden="true"
                />
                <div tw="hidden group-hover:flex ml-5 left-2 absolute text-xs whitespace-nowrap bg-white pr-2">
                  {t('cahierJournal:actions.addSeanceBetweenLabel', {
                    start: startString,
                    end: endString,
                  })}
                </div>
              </button>
            </span>
          </div>
        </>
      )}
    </div>
  );
}
